<div class="modal-header">
    <h3 class="modal-title">Send Reminder</h3>
</div>
<div class="modal-body">
    <p>This will notify all employees that have not yet signed or acknowledged the following document:</p>
    <p><b>{{bulletin.BulletinHeadline}}</b></p>
    <p>Continue?</p>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="sendClicked()">Send</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>